import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface RelatedLink {
  title: string;
  description: string;
  href: string;
}

interface RelatedServicesProps {
  current: "individuals" | "companies" | "students";
}

const ALL: Record<RelatedServicesProps["current"], RelatedLink> = {
  individuals: {
    title: "1:1 Life & Career Coaching for Professionals",
    description: "Personal branding, career clarity and burnout recovery with Mahirah.",
    href: "/services/individuals",
  },
  companies: {
    title: "Corporate Leadership & Soft Skills Training",
    description: "Executive presence, communication and POSH programmes for teams in Dubai and India.",
    href: "/services/companies",
  },
  students: {
    title: "Campus to Corporate Soft Skills Training",
    description: "Workplace readiness workshops for final-year students and graduate trainees.",
    href: "/services/students",
  },
};

const RelatedServices = ({ current }: RelatedServicesProps) => {
  const others = (Object.keys(ALL) as RelatedServicesProps["current"][]).filter((k) => k !== current);
  return (
    <section className="bg-secondary/40 py-14">
      <div className="container mx-auto px-4">
        <h2 className="mb-6 text-center text-2xl font-heading font-bold text-foreground md:text-3xl">
          Related MVIBE programmes
        </h2>
        <div className="mx-auto grid max-w-4xl gap-4 md:grid-cols-3">
          {others.map((k) => {
            const item = ALL[k];
            return (
              <Link
                key={k}
                to={item.href}
                className="group rounded-xl border border-border bg-card p-5 transition hover:border-accent"
              >
                <h3 className="mb-2 text-lg font-heading font-semibold text-foreground group-hover:text-accent">
                  {item.title}
                </h3>
                <p className="mb-3 font-sans text-sm text-muted-foreground">{item.description}</p>
                <span className="inline-flex items-center gap-1 font-sans text-sm text-accent">
                  Learn more <ArrowRight className="h-4 w-4" />
                </span>
              </Link>
            );
          })}
          <Link
            to="/about"
            className="group rounded-xl border border-border bg-card p-5 transition hover:border-accent"
          >
            <h3 className="mb-2 text-lg font-heading font-semibold text-foreground group-hover:text-accent">
              Meet Mahirah, ICF-aligned Executive Coach
            </h3>
            <p className="mb-3 font-sans text-sm text-muted-foreground">
              15+ years of corporate leadership behind every MVIBE programme.
            </p>
            <span className="inline-flex items-center gap-1 font-sans text-sm text-accent">
              About MVIBE <ArrowRight className="h-4 w-4" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RelatedServices;
